module.exports = __webpack_public_path__ + "img/health_safety.33198221.jpg";